import * as actionTypes from '../actions/actionTypes'

const initialState = {
  pagination: { total: 0, to: 0, lastPage: 1, from: 0, currentPage: 1, perPage: 10 },
  records: [],
  loading: false,
  filterLoading: false,
  success: false,
  selectedRecord: null,
  role: [],
  filterUser: [],
  roleOption: []
}

const fetchUserStart = (state, action) => {
  return { ...state, loading: true }
}

const fetchUserSuccess = (state, action) => {
  return {
    ...state,
    loading: false,
    pagination: action.pagination,
    records: action.records
  }
}

const fetchUserFailed = (state, action) => {
  return {
    ...state,
    loading: false,
    message: action.errorMessage
  }
}

const fetchUserByIdSuccess = (state, action) => {
  let select = action.recordData
  let company_id = select.employee ? select.employee.company.company_id : null

  select = { ...select, company_id }

  return {
    ...state,
    loading: false,
    selectedRecord: select
  }
}

const clearSelectedUserRecord = (state, action) => {
  return {
    ...state,
    selectedRecord: { is_active: true },
    success: false
  }
}

const createUserStart = (state, action) => {
  return { ...state, loading: true }
}

const createUserSuccess = (state, action) => {
  return {
    ...state,
    loading: false,
    success: true
  }
}

const createUserFailed = (state, action) => {
  return {
    ...state,
    loading: false,
    success: false
  }
}

const updateUserStart = (state, action) => {
  return {
    ...state,
    loading: true
  }
}

const updateUserSuccess = (state, action) => {
  return {
    ...state,
    loading: false,
    success: true
  }
}

const updateUserFailed = (state, action) => {
  return {
    ...state,
    loading: false,
    success: false
  }
}

const deleteUserStart = (state, action) => {
  return { ...state, loading: true }
}

const deleteUserSuccess = (state, action) => {
  return {
    ...state,
    loading: false,
    success: true
  }
}

const deleteUserFailed = (state, action) => {
  return {
    ...state,
    loading: false,
    success: false
  }
}

const fetchRoleStart = (state, action) => {
  return { ...state, loading: true }
}

const fetchRoleSuccess = (state, action) => {
  return {
    ...state,
    loading: false,
    role: action.data
  }
}

const fetchRoleFailed = (state, action) => {
  return {
    ...state,
    loading: false,
    message: action.errorMessage
  }
}

const fetchUserFilterStart = (state, action) => {
  return { ...state, filterLoading: true }
}

const fetchUserFilterSuccess = (state, action) => {
  return {
    ...state,
    filterLoading: false,
    filterUser: action.data
  }
}

const fetchUserFilterFailed = (state, action) => {
  return {
    ...state,
    filterLoading: false,
    message: action.errorMessage
  }
}
const fetchOptionRoleStart = (state, action) => {
  return { ...state, loading: true }
}

const fetchOptionRoleSuccess = (state, action) => {
  return {
    ...state,
    loading: false,
    roleOption: action.data
  }
}

const fetchOptionRoleFailed = (state, action) => {
  return {
    ...state,
    loading: false,
    message: action.errorMessage
  }
}
const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_USER_START:
      return fetchUserStart(state, action)
    case actionTypes.FETCH_USER_SUCCESS:
      return fetchUserSuccess(state, action)
    case actionTypes.FETCH_USER_BY_ID_SUCCESS:
      return fetchUserByIdSuccess(state, action)
    case actionTypes.FETCH_USER_FAILED:
      return fetchUserFailed(state, action)
    case actionTypes.CLEAR_SELECTED_USER_RECORD:
      return clearSelectedUserRecord(state, action)
    case actionTypes.CREATE_USER_START:
      return createUserStart(state, action)
    case actionTypes.CREATE_USER_SUCCESS:
      return createUserSuccess(state, action)
    case actionTypes.CREATE_USER_FAILED:
      return createUserFailed(state, action)
    case actionTypes.UPDATE_USER_START:
      return updateUserStart(state, action)
    case actionTypes.UPDATE_USER_SUCCESS:
      return updateUserSuccess(state, action)
    case actionTypes.UPDATE_USER_FAILED:
      return updateUserFailed(state, action)
    case actionTypes.DELETE_USER_START:
      return deleteUserStart(state, action)
    case actionTypes.DELETE_USER_SUCCESS:
      return deleteUserSuccess(state, action)
    case actionTypes.DELETE_USER_FAILED:
      return deleteUserFailed(state, action)
    case actionTypes.FETCH_USER_ROLE_OPTION_START:
      return fetchRoleStart(state, action)
    case actionTypes.FETCH_USER_ROLE_OPTION_SUCCESS:
      return fetchRoleSuccess(state, action)
    case actionTypes.FETCH_USER_ROLE_OPTION_FAILED:
      return fetchRoleFailed(state, action)
    case actionTypes.FETCH_USER_FILTER_START:
      return fetchUserFilterStart(state, action)
    case actionTypes.FETCH_USER_FILTER_SUCCESS:
      return fetchUserFilterSuccess(state, action)
    case actionTypes.FETCH_USER_FILTER_FAILED:
      return fetchUserFilterFailed(state, action)
    case actionTypes.FETCH_ROLE_OPTIONS_SUCCESS:
      return fetchOptionRoleSuccess(state, action)
    case actionTypes.FETCH_ROLE_OPTIONS_START:
      return fetchOptionRoleStart(state, action)
    case actionTypes.FETCH_ROLE_OPTIONS_FAILED:
      return fetchOptionRoleFailed(state, action)
    case actionTypes.SIGNOUT_SUCCESS:
    case actionTypes.SIGNOUT_FAILED:
      return { ...initialState }
    default:
      return state
  }
}

export default reducer
